document.addEventListener('DOMContentLoaded', () => {

  const heroSections = document.querySelectorAll('.hero-v3');

  heroSections.forEach((section) => {

    const thumbEl = section.querySelector('.hero-v3-thumbs');
    const mainEl = section.querySelector('.hero-v3-main');

    if (!thumbEl || !mainEl) return;

    const thumbsSwiper = new Swiper(thumbEl, {
      slidesPerView: 'auto',
      spaceBetween: 12,
      watchSlidesProgress: true,
      freeMode: true
    });

    new Swiper(mainEl, {

      effect: 'fade',

      fadeEffect: {
        crossFade: true
      },

      speed: 1200,

      loop: true,

      autoplay: {
        delay: 5000,
        disableOnInteraction: false
      },

      thumbs: {
        swiper: thumbsSwiper
      }

    });

  });

});